import axios from 'axios';
import { generateCsrfToken } from './utils/generateCsrfToken';
import { getDebugParams } from './utils/getDebugParams';
import { getAppPathPrefix } from './utils/legacyAppPath';

export function setupAxiosInterceptors(target: 'app' | 'widget'): void {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    axios.defaults.withCredentials = true;

    axios.interceptors.request.use(
        async (config) => {
            if (config.method?.toLowerCase() !== 'get') {
                config.headers['X-Csrf-Token'] = await generateCsrfToken();
            }
            const testId = new URLSearchParams(window.location.search).get('test-id');

            config.params = {
                ...getDebugParams(),
                ...(testId && { 'test-id': testId }),
                ...config.params,
            };

            return config;
        },
        (error: Error): Promise<void> => Promise.reject(error),
    );

    axios.interceptors.response.use(
        (response) => {
            const error451Url = `${window.location.origin}${getAppPathPrefix(
                window.location.pathname,
            )}/error/451`;

            if (
                target === 'app' &&
                response.headers['Decline-Reason'] === 'by-geo' &&
                `${location.protocol}//${location.host}${location.pathname}` !== error451Url
            ) {
                window.location.href = error451Url;
            }

            return response;
        },
        (error) => {
            const error451Url = `${window.location.origin}${getAppPathPrefix(
                window.location.pathname,
            )}/error/451`;

            if (
                target === 'app' &&
                error.response.status === 401 &&
                error.config.url !== '/user/actions' &&
                error.config.url !== '/user/profile'
            ) {
                window.location.href = `${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${window.location.href}`;
            }

            if (
                target === 'app' &&
                error.response.headers.get('Decline-Reason') === 'by-geo' &&
                `${location.protocol}//${location.host}${location.pathname}` !== error451Url
            ) {
                window.location.href = error451Url;
            }

            return Promise.reject(error);
        },
    );
}
